module.exports = __webpack_public_path__ + "img/full5-min.b4aaed63.png";